import React from "react";
import styles from "@bookingcom/bui-core/css/Grid.module.css";
import { classNames, responsiveClassNames, } from "@bookingcom/bui-core/utilities/classNames";
import Stack from "../Stack/index.js";
var GridColumn = function (props) {
    var _a = props.size, passedSize = _a === void 0 ? 12 : _a, sizeMedium = props.sizeMedium, sizeLarge = props.sizeLarge, passedOffset = props.offset, offsetMedium = props.offsetMedium, offsetLarge = props.offsetLarge, align = props.align, children = props.children, className = props.className, tagName = props.tagName, attributes = props.attributes;
    var responsiveOffset = typeof passedOffset === "object" || passedOffset === undefined
        ? passedOffset
        : { s: passedOffset };
    if (responsiveOffset && offsetMedium)
        responsiveOffset.m = offsetMedium;
    if (responsiveOffset && offsetLarge)
        responsiveOffset.l = offsetLarge;
    var responsiveSize = typeof passedSize === "object" || passedSize === undefined
        ? passedSize
        : { s: passedSize };
    if (responsiveSize && sizeMedium)
        responsiveSize.m = sizeMedium;
    if (responsiveSize && sizeLarge)
        responsiveSize.l = sizeLarge;
    var rootClassName = classNames(className, styles.column, responsiveClassNames(styles, "column--size", responsiveSize), responsiveClassNames(styles, "column--offset", responsiveOffset));
    return (React.createElement(Stack.Item, { tagName: tagName, attributes: attributes, className: rootClassName, alignSelf: align }, children));
};
export default GridColumn;
